import React from 'react';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { desktop, useBreakpoint } from '~/techstyle-shared/react-components';

import useBuilderConstructorGridInputs from '../../hooks/useBuilderConstructorGridInputs';
import useProductGridData from '../../hooks/useProductGridData';
import {
  isFacetOptionSelected,
  updateFiltersInUrlParams,
} from '../../utils/filters';
import { scrollToTopOfGrid } from '../../utils/scroll';

const AssetCardButton = styled.button`
  border: ${({ $isSelected, theme }) =>
    $isSelected
      ? `4px solid ${theme.colors.palette.black}`
      : `4px solid ${theme.colors.gridDiscoveryGuideAssetCardInactiveBorderColor}`};
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
  padding: 0;
  font-family: inherit;
  cursor: pointer;

  &:hover {
    border: 4px solid ${({ theme }) => theme.colors.palette.black};
  }
`;

const AssetCardImage = styled.img`
  width: 165px;
  height: 310px;

  ${desktop`
    width: 300px;
    height: 480px;
  `}
`;

const DiscoveryGuideFilterAssetCard = ({
  imageFilename,
  label,
  options,
  onLoad = () => {},
  id,
}) => {
  const { selectedUrlFilters } = useProductGridData();
  const { gridStyleGuide } = useBuilderConstructorGridInputs();
  const router = useRouter();
  const { isMobile } = useBreakpoint();

  const facetName = `tag_${gridStyleGuide?.tagList}_list`;
  const facetOption = options?.customVars?.tag_name;

  const isSelected = isFacetOptionSelected({
    facetName,
    facetOption,
    selectedUrlFilters,
  });

  const handleClick = () => {
    updateFiltersInUrlParams({
      facetName,
      facetOption,
      router,
    });
    scrollToTopOfGrid({ isMobile });
  };

  return (
    <AssetCardButton
      type="button"
      onClick={handleClick}
      $isSelected={isSelected}
      data-testid={`asset-${id}`}
    >
      <AssetCardImage src={imageFilename} alt={label} onLoad={onLoad} />
    </AssetCardButton>
  );
};

DiscoveryGuideFilterAssetCard.propTypes = {
  id: PropTypes.number,
  imageFilename: PropTypes.string,
  label: PropTypes.string,
  onLoad: PropTypes.func,
  options: PropTypes.shape({
    customVars: PropTypes.shape({
      tag_name: PropTypes.string,
    }),
  }),
};

export default DiscoveryGuideFilterAssetCard;
